// cross-border-lazy.js
// Handles clicks on lazy locale/country triggers (header, mobile-menu).
// On click: scroll to footer's full localization form and open the matching popout.
(function() {
  function findFooterForm() {
    return document.querySelector('.section-footer .localization-form, footer .localization-form, .footer .localization-form');
  }

  function findFooterPopout(target) {
    var form = findFooterForm();
    if (!form) return null;
    if (target === 'country') {
      return form.querySelector('.select-popout--country');
    } else if (target === 'lang') {
      return form.querySelector('.select-popout--lang');
    }
    return form.querySelector('popout-select, .select-popout');
  }

  function closeMobileDrawer() {
    // Try common drawer close mechanisms
    var openDrawer = document.querySelector('.mobile-menu.is-open, [data-drawer-open], .drawer--open');
    if (openDrawer) {
      var closeBtn = openDrawer.querySelector('[data-drawer-close], .drawer__close');
      if (closeBtn) closeBtn.click();
    }
  }

  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-cross-border-trigger]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();

    var target = trigger.dataset.target || 'country';
    closeMobileDrawer();

    var popout = findFooterPopout(target);
    if (!popout) return;

    var footerForm = findFooterForm();
    if (footerForm) {
      footerForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    // After scroll completes, open the popout
    setTimeout(function() {
      var toggle = popout.querySelector('[data-popout-toggle], .select-popout__toggle');
      if (toggle) {
        toggle.click();
      }
    }, 600);
  });
})();
